import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Grid,
  MenuItem,
  CircularProgress,
  Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
  cancelarTrasladoCompleto,
  getMotivosAnulacionTraslado
} from '../../../../../actions/traslados';
import snackbarUtils from '../../../../../utils/snackbarUtils';
import FormikSelect from '../../../../commons/formik/formikSelect';
import FormikTextField from '../../../../commons/formik/formikTextField';
import { StyledTrasladosDialog } from '../../../../styled/traslados';

const CancelarTrasladoCompletoDialog = ({ open, onClose, data, onRefresh }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const motivosAnulacion = useSelector((state) => state.traslados.motivosAnulacion);

  useEffect(() => {
    if (open) {
      dispatch(getMotivosAnulacionTraslado());
    }
  }, [open, dispatch]);

  if (!data) return null;

  const handleSubmit = (values) => {
    setLoading(true);
    dispatch(cancelarTrasladoCompleto(data.idTraslado, parseInt(values.idMotivo), values.observaciones))
      .then(() => {
        snackbarUtils.success("Traslado cancelado correctamente.");
        onRefresh?.();
        onClose();
      })
      .catch(() => {
        snackbarUtils.error("Ocurrió un error al cancelar el traslado completo.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <StyledTrasladosDialog.Header bgcolor="#8b0000">
        Cancelar Traslado Completo {data.nroTraslado || data.idTraslado}
        <StyledTrasladosDialog.CloseButton
          aria-label="close"
          onClick={onClose}
        >
          <CloseIcon />
        </StyledTrasladosDialog.CloseButton>
      </StyledTrasladosDialog.Header>
      <Formik
        initialValues={{
          idMotivo: '',
          observaciones: ''
        }}
        validationSchema={Yup.object().shape({
          idMotivo: Yup.string().required('El motivo es requerido'),
          observaciones: Yup.string().required('Las observaciones son requeridas')
        })}
        onSubmit={handleSubmit}
      >
        {({ submitForm }) => (
          <Form>
            <DialogContent sx={{ mt: 2 }}>
              <Alert severity="warning" sx={{ mb: 3 }}>
                Se cancelarán en una sola operación todos los tramos cancelables de este traslado con el motivo y observaciones indicados.
              </Alert>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikSelect name="idMotivo" label="Motivo *" fullWidth loading={motivosAnulacion?.isFetching}>
                    <MenuItem value="">Seleccionar motivo...</MenuItem>
                    {motivosAnulacion?.data?.map((m) => (
                      <MenuItem key={m.idMotivo} value={m.idMotivo}>{m.descripcion}</MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
                <Grid item xs={12}>
                  <FormikTextField name="observaciones" label="Observaciones *" fullWidth multiline rows={3} />
                </Grid>
              </Grid>
            </DialogContent>
            <StyledTrasladosDialog.Actions>
              <Button onClick={onClose} color="inherit" disabled={loading}>Volver</Button>
              <StyledTrasladosDialog.DarkRedButton
                onClick={submitForm}
                variant="contained"
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Cancelar Traslado"}
              </StyledTrasladosDialog.DarkRedButton>
            </StyledTrasladosDialog.Actions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CancelarTrasladoCompletoDialog;
